import { StateEntity } from '../entities/state-entity';

export default class State {
  items: Array<StateEntity> = [];
}
